<template>
  <div>
    <div class="business">
      <div class="top-bar">
        <span @click="backToEmployeeList">
          <i class="left"></i>
        </span>
        <span class="heading_new">Edit LOP/RLOP</span>
      </div>

      <div class="content-new">
        <toast-message
          :message="errmsg"
          type="error"
          :isToastEnable="toast"
          @close="(val) => toast = val"
        />

        <div class="selected-employees-list">
          <selected-employee-card
            v-bind:empName="`${empName}`"
            v-bind:empId="`${empId}`"
            v-bind:empMail="`${empMail}`"
            @click="closeCard"
          ></selected-employee-card>
        </div>
        <br />
        <div>
          <section class="singleColumnGrid">
            <div class="h3">LOP</div>
            <div>
              <tl-select
                label="Select Days/Dates"
                class="custom-width-days"
                v-model="selectDaysDates"
                :disabled="true"
                :options="selectDaysDatesOptions"
                @change="(val)=>selectDaysDates = val"
              />
            </div>
            <data-table
              class="margintop-20"
              v-if="selectDaysDates=='No. of Days'"
              :columns="columnNames"
              :tableData="lopData"
              :checkbox="false"
              :showinrow="false"
            >
              <template v-slot:rowcontent="slotprops">
                <p
                  v-if="slotprops.value.column.key=='month_name'"
                >{{slotprops.value.record[slotprops.value.column.key]}}</p>
                <p
                  v-if="slotprops.value.column.key=='no_of_lop'"
                >{{slotprops.value.record[slotprops.value.column.key]}}</p>
                <div class="inc-dec-bar" v-if="slotprops.value.column.key=='noofdays'">
                  <img
                    class="inc"
                    src="@/assets/stroke-1-copy.svg"
                    @click="increase('LOP', slotprops.value.index)"
                  />
                  <p>{{slotprops.value.record['noofdays']}}</p>
                  <img
                    class="dec"
                    src="@/assets/stroke-1-copy.svg"
                    @click="decrease('LOP',slotprops.value.index)"
                  />
                </div>
              </template>
            </data-table>
            <div class="row">
              <div class="col-3">
                <div v-if="selectDaysDates=='Date/s'" class="label">Date/s</div>
                <date-picker
                  v-if="selectDaysDates=='Date/s'"
                  @datevalue="(val)=>lopDate=val"
                  :dates-disabled="{from: new Date()}"
                  label="Date/s"
                  :value="lopDate"
                  class="customwidth"
                />
              </div>
              <div class="col-3 padding-t-m">
                <div
                  class="selectedDates"
                  v-if="selectDaysDates=='Date/s' && (lopData[0].lop_days.length || lopDate)"
                >
                  Selected Dates:
                  <span
                    class="dates"
                    v-for="(item, index) in lopData[0].lop_days"
                    :key="index"
                  >{{(lopData[0].lop_days.length-1) > index ? item +', ': item}}</span>
                </div>
              </div>
            </div>
            <div class="h3">RLOP</div>
            <div>
              <tl-select
                label="Select Days/Dates"
                class="custom-width-days"
                v-model="selectDaysDatesRlop"
                :disabled="true"
                :options="selectDaysDatesOptions"
                @change="(val)=>selectDaysDatesRlop = val"
              />
            </div>
            <data-table
              class="margintop-20"
              v-if="selectDaysDatesRlop=='No. of Days'"
              :columns="rlopColumnNames"
              :tableData="rlopData"
              :checkbox="false"
              :showinrow="false"
            >
              <template v-slot:rowcontent="slotprops">
                <p
                  v-if="slotprops.value.column.key=='month_name'"
                >{{slotprops.value.record[slotprops.value.column.key]}}</p>
                <p
                  v-if="slotprops.value.column.key=='no_of_lop'"
                >{{slotprops.value.record[slotprops.value.column.key]}}</p>
                <p
                  v-if="slotprops.value.column.key=='no_of_rlop'"
                >{{slotprops.value.record[slotprops.value.column.key]}}</p>
                <div class="inc-dec-bar" v-if="slotprops.value.column.key=='noofdays'">
                  <img
                    class="inc"
                    :class="{'pointerEvents-none': slotprops.value.record['no_of_lop'] <= slotprops.value.record['no_of_rlop']}"
                    src="@/assets/stroke-1-copy.svg"
                    @click="increase('RLOP', slotprops.value.index)"
                  />
                  <p>{{slotprops.value.record['noofdays']}}</p>
                  <img
                    class="dec"
                    src="@/assets/stroke-1-copy.svg"
                    @click="decrease('RLOP',slotprops.value.index)"
                  />
                </div>
              </template>
            </data-table>
            <div class="row">
              <div class="col-3">
                <div v-if="selectDaysDatesRlop=='Date/s'" class="label">Date/s</div>
                <date-picker
                  v-if="selectDaysDatesRlop=='Date/s'"
                  @datevalue="(val)=>lopDate=val"
                  :dates-disabled="{from: new Date()}"
                  label="Date/s"
                  :value="rlopDate"
                  class="customwidth"
                />
              </div>
              <div class="col-3 padding-t-m">
                <div
                  class="selectedDates"
                  v-if="selectDaysDatesRlop=='Date/s' && (rlopData[0].rlop_days || rlopDate)"
                >
                  Selected Dates:
                  <span
                    class="dates"
                    v-for="(item, index) in rlopData[0].rlop_days"
                    :key="index"
                  >{{(rlopData[0].rlop_days.length-1) > index ? item +', ': item}}</span>
                </div>
              </div>
            </div>
          </section>
        </div>

        <pop-up-message
          v-if="showEditSuccessMsg"
          message="LOP and RLOP has been successfully updated"
          btnText="Back To Employee List"
          @back="backToEmployeeList"
        ></pop-up-message>

        <bottom-action-container>
          <template slot="end">
            <btn-grp class="form-button">
              <btn text="Cancel" type="secondary" @click="backToEmployeeList" />
              <btn text="Update" type="primary" @click="performAction" />
            </btn-grp>
          </template>
        </bottom-action-container>
      </div>
    </div>
  </div>
</template>
<script>
import SelectedEmployeeCard from "@/components/dashboard/selectedEmployeeCard.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import { monthOptionsObj } from "../../../../../../../apis/constants.js";
export default {
  components: { SelectedEmployeeCard },
  data() {
    return {
      columnNames: [
        {
          label: "Month",
          key: "month_name"
        },
        {
          label: "LOPs",
          key: "no_of_lop"
        },
        {
          label: "No. of Days",
          key: "noofdays"
        }
      ],
      rlopColumnNames: [
        {
          label: "Month",
          key: "month_name"
        },
        {
          label: "LOPs",
          key: "no_of_lop"
        },
        {
          label: "RLOPs",
          key: "no_of_rlop"
        },
        {
          label: "No. of Days",
          key: "noofdays"
        }
      ],
      rlopData: [],
      lopData: [],
      empName: "",
      empId: "",
      empMail: "",
      selectDaysDates: "",
      selectDaysDatesRlop: "",
      errmsg: "",
      toast: false,
      lopDate: "",
      rlopDate: "",
      showEditSuccessMsg: false,
      selectDaysDatesOptions: ["No. of Days", "Date/s"],
      financialMonthOptions: monthOptionsObj.monthListForFinancialYear,
      monthOptions: monthOptionsObj.onlyMonths
    };
  },
  mounted() {},
  activated() {
    this.fetchAll();
  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    ...mapState({
      lopRlopData: state => state.dashboard.payroll.utilities.lopsandrlop
    }),
    leId() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    }
  },
  methods: {
    ...mapActions({
      act_create: "dashboard/payroll/utilities/uploadloprlop/create",
      act_fetchlop: "dashboard/payroll/utilities/uploadloprlop/fetchLOPsByEmp"
    }),

    /* function to come back to employee list page */
    backToEmployeeList() {
      this.showEditSuccessMsg = false;
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/upload_lop_rlop`
      });
    },

    /* server call to get lop/ rlop data of the employee */
    async fetchAll() {
      try {
        let res = await this.act_fetchlop(this.$route.query.id);
        this.empName = res.data.payload[0].name;
        this.empId = res.data.payload[0].code;
        this.empMail = "abcd@gmail.com";
        let d = new Date();
        let currentMonth = d.getMonth();
        this.lopData = [];
        this.rlopData = [];
        let index = this.financialMonthOptions.findIndex(
          item => item.name == this.monthOptions[currentMonth]
        );
        let monthList = this.financialMonthOptions.slice(0, index + 1);
        if (
          res.data.payload[0].no_of_lop_days &&
          Object.keys(res.data.payload[0].no_of_lop_days).length
        ) {
          this.selectDaysDates = "No. of Days";
        } else if (
          res.data.payload[0].lop_days &&
          res.data.payload[0].lop_days.length
        ) {
          this.selectDaysDatesRlop = "Date/s";
        }
        monthList.forEach(element => {
          let obj =
            res.data.payload.length && res.data.payload[0].no_of_lop_days
              ? res.data.payload[0].no_of_lop_days[element.value]
              : 0;
          this.lopData.push({
            no_of_lop: obj ? obj : 0,
            lop_days: res.data.payload.length
              ? res.data.payload[0].lop_days
              : [],
            month_name: element.name,
            month: element.value,
            monthIndex: element.index,
            financial_year:
              new Date().getMonth() > 2
                ? new Date().getFullYear()
                : new Date().getFullYear() - 1,
            noofdays: 0
          });
        });
        if (
          res.data.payload[0].no_of_rlop_days &&
          Object.keys(res.data.payload[0].no_of_rlop_days).length
        ) {
          this.selectDaysDatesRlop = "No. of Days";
        } else if (
          res.data.payload[0].rlop_date &&
          res.data.payload[0].rlop_date.length
        ) {
          this.selectDaysDatesRlop = "Date/s";
        }
        monthList.forEach(element => {
          let obj1 =
            res.data.payload.length && res.data.payload[0].no_of_rlop_days
              ? res.data.payload[0].no_of_rlop_days[element.value]
              : 0;
          let obj2 =
            res.data.payload.length && res.data.payload[0].no_of_lop_days
              ? res.data.payload[0].no_of_lop_days[element.value]
              : 0;
          this.rlopData.push({
            no_of_rlop: obj1 ? obj1 : 0,
            no_of_lop: obj2 ? obj2 : 0,
            rlop_days: res.data.payload.length
              ? res.data.payload[0].rlop_days
              : [],
            month_name: element.name,
            month: element.value,
            monthIndex: element.index,
            financial_year:
              new Date().getMonth() > 2
                ? new Date().getFullYear()
                : new Date().getFullYear() - 1,
            noofdays: 0
          });
        });
      } catch (err) {
        this.toast = true;
        this.errmsg = err.message;
      }
    },

    /* server call to submit the edited lop/rlop data */
    async performAction() {
      try {
        let reqObjList = [];
        let tempArray = [];
        let empID = "";
        let d = new Date();
        if (this.lopData.length > 8) {
          this.lopData.forEach(element1 => {
            let indexArray = [0, 1, 2];
            if (indexArray.some(item => item === element1.monthIndex)) {
              element1.month = element1.month + "/" + d.getFullYear();
            } else {
              element1.month = element1.month + "/" + (d.getFullYear() - 1);
            }
          });
        } else {
          this.lopData.forEach(element2 => {
            element2.month = element2.month + "/" + d.getFullYear();
          });
        }
        this.lopData.forEach(item => {
          tempArray.push({
            month: item.month,
            no_of_lop: item.no_of_lop
          });
        });
        reqObjList.push({
          lop: tempArray,
          financial_year:
            new Date().getMonth() > 2
              ? new Date().getFullYear()
              : new Date().getFullYear() - 1,
          processing_month_lop: this.financialMonthOptions.find(
            item => item.name == this.monthOptions[new Date().getMonth()]
          ).value,
          employee_id: this.$route.query.id
        });
        let rlopTempArray = [];
        if (this.rlopData.length > 8) {
          this.rlopData.forEach(element1 => {
            let indexArray = [0, 1, 2];
            if (indexArray.some(item => item === element1.monthIndex)) {
              element1.month = element1.month + "/" + d.getFullYear();
            } else {
              element1.month = element1.month + "/" + (d.getFullYear() - 1);
            }
          });
        } else {
          this.rlopData.forEach(element2 => {
            element2.month = element2.month + "/" + d.getFullYear();
          });
        }
        this.rlopData.forEach(item => {
          rlopTempArray.push({
            month: item.month,
            no_of_rlop: item.no_of_rlop
          });
        });
        reqObjList.push({
          rlop: rlopTempArray,
          financial_year:
            new Date().getMonth() > 2
              ? new Date().getFullYear()
              : new Date().getFullYear() - 1,
          processing_month_rlop: this.financialMonthOptions.find(
            item => item.name == this.monthOptions[new Date().getMonth()]
          ).value,
          employee_id: this.$route.query.id
        });
        this.$root._data.isSaving = true;
        let res = await this.act_create(reqObjList);
        setTimeout(() => {
          if (res.data.status) {
            this.showEditSuccessMsg = true;
            this.$root._data.isSaving = false;
          }
        }, 500);
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to increase lop/rlop count */
    increase(val, index) {
      try {
        if (val == "LOP") {
          this.lopData[index].no_of_lop += 0.5;
          this.lopData[index].noofdays += 0.5;
        } else {
          this.rlopData[index].no_of_rlop += 0.5;
          this.rlopData[index].noofdays += 0.5;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to decrease lop/rlop count */
    decrease(val, index) {
      try {
        if (val == "LOP") {
          // PL-1824, 20/11/2019
          if (this.lopData[index].no_of_lop) {
            if (this.lopData[index].noofdays) {
              this.lopData[index].no_of_lop -= 0.5;
              this.lopData[index].noofdays -= 0.5;
            }
          }
        } else {
          if (this.rlopData[index].no_of_rlop) {
            if (this.rlopData[index].noofdays) {
              this.rlopData[index].no_of_rlop -= 0.5;
              this.rlopData[index].noofdays -= 0.5;
            }
          }
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    }
  }
};
</script>
<style scoped lang="scss">
.business {
  width: 100%;
  height: 100%;
  margin-bottom: 200px;
}
.top-bar {
  height: auto;
  padding: 20px;
  background-color: #34c0be;
  display: flex;
}

.heading_new {
  width: auto;
  font-family: Montserrat;
  font-size: 24px;
  font-weight: bold;
  color: #ffffff;
  height: auto;
}
.pointerEvents-none {
  pointer-events: none;
}
.h3 {
  font-size: 14px;
  font-weight: 600;
  color: #000000;
}
.left {
  border: solid white;
  border-width: 0 2px 2px 0;
  padding: 5px;
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
  margin-top: 9px;
  margin-right: 15px;
  cursor: pointer;
}
.selectedDates {
  width: auto;
  height: 18px;
  opacity: 0.5;
  font-size: 14px;
  font-weight: 600;
  color: #000000;
  .dates {
    font-weight: 500;
    color: #000;
  }
}
.content-new {
  margin: 32px 32px;
}
.inc-dec-bar {
  width: 110px;
  height: 35px;
  display: flex;
  border-radius: 4px;
  border: solid 1px #dadada;
  background-color: #ffffff;
  justify-content: space-between;
  align-items: center;
  .inc {
    padding: 12px 10px 10px 10px;
    width: 32px;
    height: 35px;
    border-radius: 4px;
    transform: scaleY(-1);
    border: solid 1px #34c0be;
    cursor: pointer;
  }
  .dec {
    padding: 0px 10px;
    cursor: pointer;
    width: 32px;
    height: 35px;
    border-radius: 4px;
    border: solid 1px #34c0be;
  }
  // p {
  //   padding: 8px 0 0 10px;
  // }
}
</style>
